import { useRouter } from 'next/router';
import { Box, Link, Typography } from '@mui/material';
import styles from '@styles/propertySearchPageStyles';
import React from 'react';
import { Button } from '@foxtons/fdl/components/Button/index';
import SearchHome from '@foxtons/fdl/icons/SearchHome';

function NotValidResponseFound({ isSaleSearch }: { isSaleSearch: boolean }) {
  const router = useRouter();
  const path = router.pathname;

  return (
    <Box sx={styles.notFoundContainer}>
      <Box sx={styles.notFoundIconBox}>
        <SearchHome />
      </Box>
      <Typography variant="h3">
        Sorry, we did not understand that location
      </Typography>
      <Typography variant="body1">Please, check and try again</Typography>
      <Link
        prefetch={false}
        href={path.slice(0, path.lastIndexOf('/'))}
        passHref
      >
        <Button variant="primary" sx={styles.buttonTransform}>
          Start a new search
        </Button>
      </Link>
      <Link
        prefetch={false}
        href={
          isSaleSearch
            ? `/properties-to-rent/south-east-england`
            : `/properties-for-sale/south-east-england`
        }
      >
        {isSaleSearch
          ? 'Or search properties to rent instead?'
          : 'Or search properties for sale instead?'}
      </Link>
    </Box>
  );
}

export default NotValidResponseFound;
